import request from "../../assets/js/Request.js";

// 获取新闻列表
export const getNewList = (params) => {
  return request.get("announcements?"+params);
};
// 获取新闻详情
export const getNewDetails = (params) => {
  return request.get("announcement/detail?id="+params);
};
